import Tree from "antd/es/tree/Tree";
import { useEffect, useRef, useState } from "react";

const Outliner = (props) => {

    const [checkedKeys, setCheckedKeys] = useState([]);

    const getAllKeys = (treeData) => {
        if (treeData != null) {
            let result = [];
            treeData.forEach((x) => {
                let childKeys = [];
                if (x.children) {
                    childKeys = getAllKeys(x.children);
                }

                result.push(...[x.key, ...childKeys]);
            });

            return result;
        }
        else {
            return [];
        }
    };

    useEffect(() => {
        if (props.data != null) {
            const allKeys = getAllKeys(props.data);
            setCheckedKeys(allKeys);
        }
    }, [props.data]);

    const onCheck = (_checkedKeys, info) => {
        setCheckedKeys(_checkedKeys);
        props.onVisibilityChanged(_checkedKeys);
    };

    const onSelect = (selectedKeys, info) => {
        props.onSelectionChanged(selectedKeys[0]);
    };

    return (
        <div className="outliner">
            <Tree
                style={{ fontSize: "small" }}
                defaultExpandedKeys={props.data != null ? [(props.data)[0]['key']] : [] }
                showLine
                checkable
                checkedKeys={checkedKeys}
                onSelect={onSelect}
                onCheck={onCheck}
                treeData={props.data} />
        </div>
    );
};

export default Outliner;